import styled from 'styled-components'

export const Container = styled.section`
    float: left;
    width: 100%;
    padding: 90px 60px;
    background-color: #0F1A2A;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media (max-width: 768px) {
        
        padding: 50px 15px;

    }
`

export const Titulo = styled.span`
    float: left;
    width: 100%;
    color: #fff;
    text-align: center;
    font-size: 30px;
    line-height: 40px;
    font-weight: 600;
    margin: 0 0 60px 0;

    strong {
        color: #F09C00;
        font-weight: 600;
    }

    @media (max-width: 768px) {

        font-size: 22px;
        line-height: 32px;
        margin: 0 0 40px 0;
        
        br {
            display: none;
        }

    }
`

export const BoxItensInclusos = styled.section`
    border-radius: 8px;
    background-image: linear-gradient(to bottom right, #475568, #4C4E4C);
    box-shadow: 24px 0 40px 0 rgba(34, 34, 34, 0.16);
    padding: 20px;
    width: 450px;
    max-width: 100%;

    @media (max-width: 768px) {
        width: 100%;
        padding: 15px;
    }
`

export const BoxItensInclusosTitulo = styled.span`
    float: left;
    width: 100%;
    color: #fff;
    text-align: center;
    font-size: 30px;
    line-height: 40px;
    font-weight: 600;
    margin: 0 0 30px 0;

    @media (max-width: 768px) {
        font-size: 22px;
        line-height: 32px;
        margin: 0 0 20px 0;
    }
`

export const BoxItensInclusosLista = styled.ul`
    float: left;
    width: 100%;
    padding: 0;
    margin: 0;
`

export const BoxItensInclusosListaItem = styled.li`
    float: left;
    width: 100%;
    list-style: none;
    display: flex;
    padding: 10px 0;
    align-items: center;
    justify-content: space-between;
`

export const BoxItensInclusosListaImg = styled.img`
    margin-right: 10px;
`

export const BoxItensInclusosListTitulo = styled.span`
    color: #fff;
    flex: 1;
    font-size: 14px;
    line-height: 20px;
`

export const BoxItensInclusosListBoxInfo = styled.div`
    position: relative;
    margin-left: 10px;
`

export const BoxItensInclusosListBoxInfoIcone = styled.img`
    cursor: pointer;
`

export const BoxItensInclusosListBoxInfoModalInfo = styled.div`
    position: absolute;
    width: 300px;
    background: #F0EFF3;
    box-shadow: 0px 8px 15px rgb(45 47 64 / 10%), 0px 1.5px 5px rgb(45 47 64 / 25%);
    border-radius: 4px;
    top: calc(100% + 15px);
    padding: 20px 10px 10px 10px;
    right: -6px;
    z-index: 1;
    display: none;

    &.active {
        display: block;
    }

    ::before {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        border-bottom: 7px solid #F0EFF3;
        right: 7px;
        top: -7px;
    }

    @media (max-width: 768px) {
        width: 250px;
    }
`

export const BoxItensInclusosListBoxInfoModalIcFechar = styled.span`
    position: absolute;
    top: 3px;
    right: 3px;
    font-size: 18px;
    cursor: pointer;
    line-height: 100%;
    margin: 0;
`

export const BoxItensInclusosListBoxInfoModalIcFecharImg = styled.img`
    width: 20px;
`

export const BoxItensInclusosListBoxInfoDescricao = styled.span`
    font-size: 11px;
    color: #222;
    margin: 0;
    font-weight: 500;
`

export const BoxItensInclusosListBoxInfoButtonVideo = styled.button`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #0057EE;
    color: #fff;
    margin-top: 10px;
    padding: 6px 0;
    border-radius: 4px;
    font-size: 13px;
    text-decoration: none;
    border: 0;
`

export const BoxItensInclusosListBoxInfoButtonVideoTexto = styled.span`
    color: #fff;
    margin-right: 10px;
`

export const BoxItensInclusosListBoxInfoButtonVideoImg = styled.img`
    display: block;
`

export const BoxItensInclusosListaAssinaturas = styled.div`
    float: left;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 5px;
    margin-top: 20px;
`

export const BoxItensInclusosListaAssinaturasCard = styled.div`
    background-color: #676965;
    border-radius: 8px;
    padding: 15px;

    @media (max-width: 768px) {
        padding: 10px;
    }
`

export const BoxItensInclusosListaAssinaturasCardTitulo = styled.span`
    float: left;
    width: 100%;
    color: #fff;
    margin-bottom: 10px;
    font-size: 16px;

    @media (max-width: 768px) {
        font-size: 14px;
    }
`

export const BoxItensInclusosListaAssinaturasCardDescricao = styled.span`
    float: left;
    width: 100%;
    color: #E2E8F0;
    margin-bottom: 30px;
    font-size: 13px;
    min-height: 15px;

    @media (max-width: 768px) {
        font-size: 12px;
    }
`

export const BoxItensInclusosListaAssinaturasCardPrecoDe = styled.span`
    float: left;
    width: 100%;
    color: #E2E8F0;
    font-size: 14px;
    margin-bottom: 7px;

    @media (max-width: 768px) {
        font-size: 12px;
    }
`

export const BoxItensInclusosListaAssinaturasCardPrecoPor = styled.span`
    float: left;
    width: 100%;
    color: #fff;
    font-weight: 900;
    font-size: 24px;
    margin-bottom: 15px;

    small {
        font-weight: 300;
    }

    @media (max-width: 768px) {
        font-size: 18px;
    }
`

export const BoxItensInclusosListaAssinaturasCardLink = styled.a`
    float: left;
    width: 100%;
    color: #fff;
    background-color: #C98400;
    padding: 10px 5px;
    font-size: 14px;
    border-radius: 4px;
    font-weight: bold;
    text-align: center;
`

export const ModalVideo = styled.div`
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.9);
    z-index: 999999999999999;
    display: none;

    &.active {
        display: block;
    }
`

export const ModalVideoFlex = styled.div`
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const ModalVideoFlexBoxVideo = styled.div`
    width: 800px;
    max-width: 90%;
    border-radius: 4px;
    background: #fff;
    padding: 30px;
    position: relative;

    @media (max-width: 768px) {
        padding: 20px;
    }
`

export const ModalVideoFlexBoxVideoBotaofechar = styled.span`
    position: absolute;
    color: #A9ABBD;
    font-weight: bold;
    top: 4px;
    right: 4px;
    font-size: 20px;
    line-height: 100%;
    cursor: pointer;

    @media (max-width: 768px) {
        right: 2px;
        top: 2px;
    }
`

export const ModalVideoFlexBoxVideoBotaofecharImg = styled.img`
    display: inline-block;
`

export const ModalVideoFlexBoxVideoIframe = styled.iframe`
    width: 100%;
    float: left;
    height: 500px;
    border-radius: 4px;

    @media (max-width: 768px) {
        height: 200px;
    }
`
